module.exports = __webpack_public_path__ + "static/media/hall-PAL.42e9593f.svg";